// extracted by mini-css-extract-plugin
export default {"button":"BlockUserButton_button__EuTL7","error":"BlockUserButton_error__0UEnn"};